import { Types } from 'mongoose';
// TODO: Oshen
export enum ReconciliationType {
  POLICY_STATEMENT = 'POLICY_STATEMENT',
  OUTSTANDING_PREMIUM = 'OUTSTANDING_PREMIUM',
  RECEIVABLE_COMMISSION = 'RECEIVABLE_COMMISSION',
}

export const RECONCILIATION_TYPE_LIST = [
  { id: ReconciliationType.POLICY_STATEMENT, value: 'Policy Statement' },
  { id: ReconciliationType.OUTSTANDING_PREMIUM, value: 'Outstanding Premium' },
  {
    id: ReconciliationType.RECEIVABLE_COMMISSION,
    value: 'Receivable Commission',
  },
];

export interface Insurer {
  id: string | Types.ObjectId;
  name: string;
}

export interface IReconcileFormData {
  type: ReconciliationType;
  insurer: string;
  dateRange: {
    start: Date;
    end: Date;
  };
}

export interface IReconcileResponse {
  adviserNumber: string;
  policyNumber: string;
  typeEntry: string;
  invoiceNumber: string;
  sumInsured: number;
}
